export function armourMinMax({ level, quality }: { level: number; quality: number }): [number, number] {
  const minBase = level + (quality + 1);
  return [minBase, minBase + 1];
}
